import React from 'react'
import { StyledFooter } from './styles/Footer.styled'
import FooterLogo from '../../../../assets/images/FooterLogo.png'
import { EmailSvg } from '../../../../assets/svgs/svg'

const Footer = () => {
  return (
    <StyledFooter>
        
        <div className="footer__logo">
         <div>  <img src={FooterLogo} alt='logo' /> </div> 
        

          <main>
              <div>
                <p> HydroCIS </p>
                <p>All rights reserved</p>
              </div>
          </main>

        </div>

        <div className="footer__content">
           <div className='footer_company'>
               <div className='fgrid'>
                  <strong>Company</strong>
                  <div>
                     <p>Home</p>
                     <p>Services</p>
                     <p>plans</p>
                     <p>Career</p>
                  </div>
               </div>
           </div>

           <div className='footer_features'>
              <strong>Features</strong>
                      <div>
                        <p>Facebook</p>
                        <p>Twitter</p>
                        <p>Instagram</p>
                      </div>
           </div>

                <div className='footer_address'>
                  <strong>Stay up to date</strong>
                  <br />
                  <div>
                    <input type='email' placeholder='Your email address'/>
                    <span><EmailSvg /></span>
                  </div>
                </div>
        </div>

    </StyledFooter>
  )
}

export default Footer